import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { ITenderRequirementItem } from 'types/tender/tenderRequirementItems'

type DocumentRequirementItemIds = {
  documentId?: number | string
  id?: number | string
}

export const tenderRequirementItemsApi = createApi({
  reducerPath: 'tenderRequirementItems',
  baseQuery,
  endpoints: (builder) => ({
    tenderRequirementItems: builder.query<
      ITenderRequirementItem[],
      DocumentRequirementItemIds
    >({
      query: ({ documentId }) => ({
        url: `/document-requirements/${documentId}/items`,
      }),
    }),

    tenderRequirementItem: builder.query<
      ITenderRequirementItem,
      DocumentRequirementItemIds
    >({
      query: ({ documentId, id }) =>
        `/document-requirements/${documentId}/items/${id}`,
    }),

    createTenderRequirementItem: builder.mutation<
      ITenderRequirementItem,
      Partial<ITenderRequirementItem>
    >({
      query: (body) => ({
        url: `/document-requirements/${body.id}/items`,
        body,
        method: 'post',
      }),
    }),

    deleteTenderRequirementItem: builder.mutation<void, DocumentRequirementItemIds>({
      query: ({ documentId, id }) => ({
        url: `/document-requirements/${documentId}/items/${id}`,
        method: 'delete',
      }),
    }),
  }),
})

export const {
  useTenderRequirementItemQuery,
  useTenderRequirementItemsQuery,
  useCreateTenderRequirementItemMutation,
  useDeleteTenderRequirementItemMutation,
} = tenderRequirementItemsApi
